import React from "react";
import { Modal } from "../../../../Components";

export default function ModalSubscribe(props) {
  return (
    <Modal addClass="modalAsset">
      <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden transform transition-all scale-95 hover:scale-100">
          {/* Header */}
          <div className="p-6 bg-gradient-to-r from-blue-50 to-green-50">
            <div className="flex items-center justify-center w-16 h-16 bg-white rounded-full mx-auto mb-4 shadow-md">
              <svg
                className="w-8 h-8 text-green-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-green-900 text-center">
              Premium Access Required
            </h3>
          </div>

          {/* Body */}
          <div className="p-6">
            <p className="text-green-600 text-center mb-4 leading-relaxed">
              You've exhausted your trial period. Upgrade now to unlock all
              premium features and continue your journey.
            </p>

            {/* Feature highlights */}
            <div className="mt-6 space-y-3">
              <div className="flex items-center">
                <div className="flex-shrink-0 h-5 w-5 text-green-600">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <p className="ml-3 text-sm text-gray-600">
                  Unlimited access to all features
                </p>
              </div>

              <div className="flex items-center">
                <div className="flex-shrink-0 h-5 w-5 text-green-600">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <p className="ml-3 text-sm text-gray-600">
                  Priority customer support
                </p>
              </div>

              <div className="flex items-center">
                <div className="flex-shrink-0 h-5 w-5 text-green-600">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <p className="ml-3 text-sm text-gray-600">
                  Regular content updates
                </p>
              </div>
            </div>
          </div>

          {/* Footer - Buttons */}
          <div className="px-6 py-4 bg-gray-50 flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-3">
            <button
              className="px-5 py-2.5 hover:shadow-lg text-sm font-semibold text-green-700 bg-white border border-green-200 rounded-lg hover:bg-green-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all duration-200"
              onClick={props.close}
            >
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
